import * as Sentry from "@sentry/nextjs";

export const getEnvironmentTag = () => {
  if (process.env.NODE_ENV === "development") {
    return "local";
  }
  if (process.env.NEXT_PUBLIC_ENV === "production") {
    return "prod";
  }
  return process.env.NEXT_PUBLIC_ENV;
};

Sentry.setTags({
  environment: getEnvironmentTag(),
});

const errorReporter = Sentry;

export default errorReporter;
